export interface sendMessagePayload {
    to: string,
    message: string,
    attachments?: {
        buffer?: string,
        fileType?: string,
        fileName?: string,
        url?: string
    }[],
    orgID: string,
    departmentID?: string,
    subject?: string,
    source: string,
    medium?: string,
    from: string,
    ticketCode?: string
}

export interface ProcessIncomingChatPayload {
    orgID: string,
    orgName?: string,
    departmentID?: string,
    channel: number,
    message: string,
    sender: string,
    subject?: string,
    ticketType?: string,
    ticketCode?: string,
    messageId?: string,
    conversationId?: string,
    source?: string,
    agentID?: string,
    agentName?: string,
    agentPix?: string,
    groupID?: string,
    location?: string,
    otherData?: any,
    aiTimeoutMs?: number,
}

export interface ResponseSuggestionPayload {
    orgID: string,
    ticketCode: string,
    partialText: string,
    context?: string,
}

export interface ResponseSuggestionItem {
    text: string,
    confidence: number,
}

export interface ResponseSuggestionResponse {
    status: string,
    message?: string,
    tone?: string,
    suggestions?: ResponseSuggestionItem[],
}

export enum TicketSource {
    WHATSAPP = 'whatsapp',
    SMS = 'sms',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TWITTER = 'twitter',
    EMAIL = 'email',
    TIKTOK = 'tiktok'
}

export enum TicketMedium {
    CLICKATELL = 'clickatell',
    VONAGE = 'vonage',
    TWILLO = 'twillo',
    WHATSAPP_WEB = 'whatsappWeb',
    META = 'meta'
}
